import { useEffect } from 'react'
import { useSelectionStore } from '@editorStores'

/**
 * Reconciles the global editor mode with the page being entered: a mode bound to a different
 * page falls back to neutral (the selection survives whenever neutral can hold it, which is the
 * "selection is kept across pages" guarantee), while page-independent modes are left untouched.
 * A mount effect by design — entering a route is the outside-world event being synced.
 */
const useEnterEditorPage = (page: EditorPage): void => {
  const enterPage = useSelectionStore(state => state.enterPage)

  useEffect(() => {
    enterPage(page)
  }, [enterPage, page])
}

export default useEnterEditorPage
